import React from 'react';
import {
  Box,
  Button,
  Grid,
  TextField,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { VisitFilters as VisitFiltersType } from '../types/VisitRecord';

interface VisitFiltersProps {
  filters: VisitFiltersType;
  onFiltersChange: (filters: VisitFiltersType) => void;
  onSearch: () => void;
  onClear: () => void;
}

const VisitFilters: React.FC<VisitFiltersProps> = ({
  filters,
  onFiltersChange,
  onSearch,
  onClear,
}) => {
  const handleFilterChange = (field: keyof VisitFiltersType, value: any) => {
    onFiltersChange({
      ...filters,
      [field]: value,
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <DateTimePicker
              label="Start Time"
              value={filters.startTime}
              onChange={(date) => handleFilterChange('startTime', date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <DateTimePicker
              label="End Time"
              value={filters.endTime}
              onChange={(date) => handleFilterChange('endTime', date)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Organization ID"
              value={filters.organizationId}
              onChange={(e) => handleFilterChange('organizationId', e.target.value)}
              placeholder="e.g., org-123"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="MSISDN"
              value={filters.msisdn}
              onChange={(e) => handleFilterChange('msisdn', e.target.value)}
              placeholder="e.g., 46701234567"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Visit Token"
              value={filters.visitToken}
              onChange={(e) => handleFilterChange('visitToken', e.target.value)}
              placeholder="e.g., VT-123456"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={onSearch}
              >
                Search
              </Button>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<ClearIcon />}
                onClick={onClear}
              >
                Clear
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </LocalizationProvider>
  );
};

export default VisitFilters;
